import React, { useState } from 'react';
import ReactTable from './ReactTable'; // Assuming ReactTable is in the same folder

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

import './css/AddressTable.css';

const AddressTable = ({ addresses }) => {
    const [editRow, setEditRow] = useState(null);
    const [editData, setEditData] = useState({});

    const handleEditClick = (rowIndex, rowData) => {
        setEditRow(rowIndex);
        setEditData(rowData);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSaveClick = () => {
        console.log('Saved data:', editData); // Implement your save logic here
        setEditRow(null);
        setEditData({});
    };

    const handleCancelClick = () => {
        setEditRow(null);
        setEditData({});
    };

    const columnDefs = [
        { headerName: 'Address Line 1', field: 'addressLine1', suppressMovable: true },
        { headerName: 'Address Line 2', field: 'addressLine2', suppressMovable: true },
        { headerName: 'City', field: 'city', suppressMovable: true },
        { headerName: 'State', field: 'state', suppressMovable: true },
        { headerName: 'Country', field: 'country', suppressMovable: true },
        { headerName: 'Postal Code', field: 'postalCode', suppressMovable: true },
        // { headerName: 'Longitude', field: 'longitude', suppressMovable: true },
        // { headerName: 'Latitude', field: 'latitude', suppressMovable: true },
        {
            headerName: 'Actions',
            field: 'actions',
            suppressMovable: true,
            cellRenderer: ({ rowIndex }) => (
                <div>
                    {editRow === rowIndex ? (
                        <>
                            <button className="address-save-button" onClick={handleSaveClick}>
                                <FontAwesomeIcon icon={faSave} />
                            </button>
                            <button className="address-cancel-button" onClick={handleCancelClick}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="address-edit-button"
                                onClick={() => handleEditClick(rowIndex, addresses[rowIndex])}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button className="address-delete-button">
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </>
                    )}
                </div>
            ),
        },
    ];

    const rowData = addresses.map((row, index) => {
        if (editRow === index) {
            return {
                ...row,
                addressLine1: (
                    <input
                        type="text"
                        name="addressLine1"
                        value={editData.addressLine1 || ''}
                        onChange={handleInputChange}
                    />
                ),
                addressLine2: (
                    <input
                        type="text"
                        name="addressLine2"
                        value={editData.addressLine2 || ''}
                        onChange={handleInputChange}
                    />
                ),
                city: (
                    <input
                        type="text"
                        name="city"
                        value={editData.city || ''}
                        onChange={handleInputChange}
                    />
                ),
                state: (
                    <input
                        type="text"
                        name="state"
                        value={editData.state || ''}
                        onChange={handleInputChange}
                    />
                ),
                country: (
                    <input
                        type="text"
                        name="country"
                        value={editData.country || ''}
                        onChange={handleInputChange}
                    />
                ),
                postalCode: (
                    <input
                        type="text"
                        name="postalCode"
                        value={editData.postalCode || ''}
                        onChange={handleInputChange}
                    />
                ),
                // longitude: (
                //     <input
                //         type="text"
                //         name="longitude"
                //         value={editData.longitude || ''}
                //         onChange={handleInputChange}
                //     />
                // ),
                // latitude: (
                //     <input
                //         type="text"
                //         name="latitude"
                //         value={editData.latitude || ''}
                //         onChange={handleInputChange}
                //     />
                // ),
            };
        }
        return row;
    });

    return <ReactTable columnDefs={columnDefs} rowData={rowData} />;
};

export default AddressTable;
